export const environment = {
  production: true,
  apiUrl: 'https://app.unesp.br/edutec2-backend/api/v1',
  centralClientId: 'unesp.sga-edutec',
  centralAuthUrl: 'https://auth.unesp.br/oauth/authorize',
  centralRedirectUri: 'https://edutec.unesp.br/oauth',
  centralLogoutUrl: 'https://auth.unesp.br/login',
  externalRedirectUrl: 'https://www2.unesp.br/portal#!/cdep3'
};
